import { StatusClassNames } from "../types/StatusClassNames";
// Ставит is-stuck элементу сразу после .sticky-sentinel, пока тот прилип.
// Прилипание может включаться только с брейкпоинта, поэтому смотрим на вычисленный position, а не дублируем медиазапрос.
export default function initStickyState() {
    document.querySelectorAll('.sticky-sentinel').forEach((sentinel) => {
        const target = sentinel.nextElementSibling;
        if (!target) {
            return;
        }
        new IntersectionObserver(([entry]) => {
            const isAbove = entry.boundingClientRect.top < 0;
            const isSticky = getComputedStyle(target).position === 'sticky';
            target.classList.toggle(StatusClassNames.stuck, isSticky && !entry.isIntersecting && isAbove);
        }).observe(sentinel);
    });
}
